<template>
  <v-container class="your-people-container standard-content-container">
    <DynamicNavDrawer
      :drawerOpen="readMoreDrawerOpen"
      @drawerClosed="drawerClosed"
      :title="sliderData.title"
      :description="sliderData.description"
    >
      <template v-slot:content>
        <Accordion
          :accordionData="getAccordionData"
          :html="true"
          :isNavDrawer="true"
        />
      </template>
    </DynamicNavDrawer>
    <v-row no-gutters>
      <v-col cols="12" md="5">
        <v-row no-gutters class="title-section">
          <v-col
            cols="12"
            sm="2"
            class="link-container"
            :class="{
              'small-container':
                this.$vuetify.breakpoint.width <=
                this.$vuetify.breakpoint.thresholds.xs,
            }"
          >
            <router-link :to="backButtonLocation" class="back-arrow"
              ><v-icon large color="mid-grey" class="mt-1">{{
                icons.mdiArrowLeft
              }}</v-icon></router-link
            >
          </v-col>
          <v-col cols="12" sm="10" class="standard-content-container">
            <h1>Your People</h1>
            <p v-if="isEmergencyContacts" class="your-people-description">
              When you die it unleashes a flurry of activity. Plan now and set
              up contacts to streamline the process after your passing.
            </p>
            <p v-else class="your-people-description">
              Tell us about your family and who you want to appoint as guardian
              of your children.
            </p>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <AdditionalInfoComponent
                v-if="childrensGuardianInfo"
                :heading="'Choosing the right guardian'"
                :source="childrensGuardianVideo"
                @drawerOpen="drawerOpen()"
              ></AdditionalInfoComponent>
              <AdditionalInfoComponent
                v-else-if="testamentaryTrustInfo"
                :heading="'Understanding Testamentary Trusts'"
                :source="testamentaryTrustVideo"
                @drawerOpen="drawerOpen()"
              ></AdditionalInfoComponent>
              <AdditionalInfoComponent
                v-else-if="executorInfo"
                :heading="'The role of an Executor'"
                :source="executorVideo"
                @drawerOpen="drawerOpen()"
              ></AdditionalInfoComponent>
              <AdditionalInfoComponent
                v-else-if="maritalRegimeInfo"
                :heading="'Implications of your marital regime'"
                :source="maritalRegimeVideo"
                @drawerOpen="drawerOpen()"
              ></AdditionalInfoComponent>
            </template>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="7" class="your-people-forms">
        <div class="left-section-container">
          <div v-if="!loading">
            <router-view
              :testator="testator"
              :relations="relations"
              @refetchQuery="$apollo.queries.testator.refetch()"
            />
          </div>
          <div v-else class="text-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <template v-if="$vuetify.breakpoint.smAndDown">
            <AdditionalInfoComponent
              v-if="childrensGuardianInfo"
              :heading="'Choosing the right guardian'"
              :source="childrensGuardianVideo"
              @drawerOpen="drawerOpen()"
            ></AdditionalInfoComponent>
            <AdditionalInfoComponent
              v-else-if="testamentaryTrustInfo"
              :heading="'Understanding Testamentary Trusts'"
              :source="testamentaryTrustVideo"
              @drawerOpen="drawerOpen()"
            ></AdditionalInfoComponent>
            <AdditionalInfoComponent
              v-else-if="executorInfo"
              :heading="'The role of an Executor'"
              :source="executorVideo"
              @drawerOpen="drawerOpen()"
            ></AdditionalInfoComponent>
            <AdditionalInfoComponent
              v-else-if="maritalRegimeInfo"
              :heading="'Marital regime implications'"
              :source="maritalRegimeVideo"
              @drawerOpen="drawerOpen()"
            ></AdditionalInfoComponent>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import { getRelations } from '../../constants/js/people.js';
  import Accordion from '../common/Accordion.vue';
  import DynamicNavDrawer from '../guest/DynamicNavDrawer.vue';
  import AdditionalInfoComponent from './AdditionalInfoComponent.vue';

  export default {
    name: 'YourPeople',
    components: {
      Accordion,
      DynamicNavDrawer,
      AdditionalInfoComponent,
    },
    data() {
      return {
        testator: {},
        relations: {},
        loading: true,
        childrensGuardianInfo: null,
        childrensGuardianVideo: null,
        testamentaryTrustInfo: null,
        testamentaryTrustVideo: null,
        maritalRegimeInfo: null,
        maritalRegimeVideo: null,
        executorInfo: null,
        executorVideo: null,
        readMoreDrawerOpen: false,
        childrensGuardianData: [],
        testamentaryTrustData: [],
        executorData: [],
        maritalRegimeData: [],
        sliderData: {
          title: null,
          description: null,
        },
      };
    },
    mounted() {
      this.childrensGuardianInfo = this.$route.name === 'ChildrensGuardian';
      this.childrensGuardianVideo =
        this.whitelabel.videos.childrensGuardianVideo;
      this.childrensGuardianData = this.whitelabel.childrensGuardianData;
      this.testamentaryTrustInfo = this.$route.name === 'ChildrensTrust';
      this.testamentaryTrustVideo =
        this.whitelabel.videos.testamentaryTrustVideo;
      this.testamentaryTrustData = this.whitelabel.testamentaryTrustData;
      this.executorInfo = this.$route.name === 'AppointExecutor';
      this.executorVideo = this.whitelabel.videos.executorVideo;
      this.executorData = this.whitelabel.executorData;
      this.maritalRegimeInfo = this.$route.name === 'MaritalRegime';
      this.maritalRegimeVideo = this.whitelabel.videos.maritalRegimeVideo;
      this.maritalRegimeData = this.whitelabel.maritalRegimeData;
      // this.childrensGuardianInfo;
      // this.testamentaryTrustInfo;
      // this.executorInfo;
      // this.maritalRegimeInfo;
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data && response.data.testator) {
            this.relations = getRelations(response.data.testator.people);
            this.loading = false;
          }
        },
      },
    },
    computed: {
      isMobile() {
        return this.$isMobileDevice();
      },
      omOnlyExecutor() {
        if (this.testator.bypassOmOnlyExecutor) {
          return false;
        }
        return (this.testator.enabledFeatures || []).includes(
          'om_only_executor'
        );
      },
      descriptionText() {
        if (this.testator.enabledFeatures && !this.omOnlyExecutor) {
          return 'Tell us about your family, who you would like to appoint as Executor of your estate, guardian(s) of your children.';
        } else {
          return '';
        }
      },
      backButtonLocation() {
        return this.$route.query.peopleWizard
          ? this.wizardBackLocation
          : { name: 'OverviewPage', hash: '#your-people' };
      },
      wizardBackLocation() {
        switch (this.$route.query.peopleWizard) {
          case 'spouse':
            return { name: 'PeopleOverview', hash: '#spouse' };
          case 'children':
            return { name: 'PeopleOverview', hash: '#children' };
          case 'guardians':
            return { name: 'PeopleOverview', hash: '#children' };
          case 'trust':
            return { name: 'PeopleOverview', hash: '#children' };
          case 'emergency-contacts':
            return { name: 'PeopleOverview', hash: '#emergency-contacts' };
          case 'executor':
            return { name: 'PeopleOverview', hash: '#executor' };
          default:
            return { name: 'PeopleOverview' };
        }
      },
      getAccordionData() {
        switch (true) {
          case this.childrensGuardianInfo:
            return this.childrensGuardianData;
          case this.testamentaryTrustInfo:
            return this.testamentaryTrustData;
          case this.executorInfo:
            return this.executorData;
          case this.maritalRegimeInfo:
            return this.maritalRegimeData;
          default:
            return [];
        }
      },
      isEmergencyContacts() {
        return this.$route.name === 'EmergencyContacts';
      },
    },
    watch: {
      $route(to, from) {
        this.showChildrensGuardianInfo(to.name === 'ChildrensGuardian');
        this.showTestamentaryTrustInfo(to.name === 'ChildrensTrust');
        this.showExecutorInfo(to.name === 'AppointExecutor');
        this.showMaritalRegimeInfo(to.name === 'MaritalRegime');
      },
      childrensGuardianInfo(val) {
        if (val) {
          this.updateSliderData(
            'Choosing the right guardian',
            'Considerations when creating your will'
          );
        }
      },
      testamentaryTrustInfo(val) {
        if (val) {
          this.updateSliderData(
            'Understandig Testamentary Trusts',
            'Considerations when creating your will'
          );
        }
      },
      executorInfo(val) {
        if (val) {
          this.updateSliderData(
            'The role of an Executor',
            'Considerations when creating your will'
          );
        }
      },
      maritalRegimeInfo(val) {
        if (val) {
          this.updateSliderData(
            'Implications of your marital regime',
            'Considerations when creating your will'
          );
        }
      },
    },
    methods: {
      showChildrensGuardianInfo(show) {
        this.childrensGuardianInfo = show;
      },
      showTestamentaryTrustInfo(show) {
        this.testamentaryTrustInfo = show;
      },
      showExecutorInfo(show) {
        this.executorInfo = show;
      },
      showMaritalRegimeInfo(show) {
        this.maritalRegimeInfo = show;
      },
      drawerOpen() {
        this.readMoreDrawerOpen = true;
      },
      drawerClosed() {
        this.readMoreDrawerOpen = false;
      },
      updateSliderData(title, description) {
        this.sliderData.title = title;
        this.sliderData.description = description;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .your-people-container {
    padding-top: 40px;
    position: relative;

    .read-more-column {
      border-top: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      padding: 30px 0;
      h2 {
        font-size: 18px;
        font-weight: 600;
        line-height: 23.4px;
        color: var(--v-primary-base);
      }

      .video-container {
        margin: 26px 0;
        video {
          width: 100%;
          max-width: 100%;
        }
      }

      .read-more {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        width: 123px;
        height: 36px;
        border-radius: 100px;
        border: 1px solid #dcddde;
        color: #282828;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: 0.4px;
        text-align: center;
        cursor: pointer;
        span {
          padding: 8px 16px;
        }
      }
    }

    .header-row {
      padding-bottom: 40px;
      display: flex;
      gap: 76px;
      h1 {
        flex: 1;
      }
      .your-people-description {
        max-width: 331px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        text-align: left;
        color: #282828;
        padding-top: 20px;
        max-width: 331px;
      }
    }
    .your-people-forms {
      text-align: left;
    }
  }
  .your-people-container.standard-content-container {
    margin-bottom: 48px;
  }
</style>
